export const CREATE_DEMATERIALIZED_FARE_MEDIA = 'createDematerializedFareMedia'
export const DOWNLOAD_FARE_MEDIA_CERTIFICATE = 'downloadFareMediaCertificate'
export const DOWNLOAD_INVOICE = 'downloadInvoice'
export const DOWNLOAD_MANDATE = 'downloadMandate'
export const DOWNLOAD_MANDATE_FORM = 'downloadMandateForm'
export const DOWNLOAD_PRODUCT_CERTIFICATE = 'downloadProductCertificate'
export const GET_FARE_MEDIA_ID_THROUGH_NFC = 'getFareMediaIdThroughNFC'
export const LOG_IN = 'logIn'
export const RELOAD_FARE_MEDIA_THROUGH_NFC = 'reloadFareMediaThroughNfc'
